module.exports = __webpack_public_path__ + "img/jiaoxuemoshi_normal.0c86404b.png";